var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestMoneyConsumer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 278,
    height: 54,
    viewBox: "0 0 278 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213bc8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7112",
    "data-name": "Group 7112",
    transform: "translate(-125 -1190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2030",
    "data-name": "Rectangle 2030",
    transform: "translate(125 1190)",
    fill: "#0e1aaa",
    stroke: "rgba(33,33,33,0.1)",
    strokeWidth: 1,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 54,
    rx: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 277,
    height: 53,
    rx: 26.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Request_money_easily",
    "data-name": "Request money easily",
    transform: "translate(289 1225)",
    fill: "#212121",
    fontSize: 20,
    fontFamily: "JioType-Medium, JioType",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -98,
    y: 0
  }, "Request money easily")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(141 1196)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_25",
    "data-name": "Polygon 25",
    d: "M8.464,1.844a2,2,0,0,1,3.073,0l5.73,6.876A2,2,0,0,1,15.73,12H4.27A2,2,0,0,1,2.734,8.72Z",
    transform: "translate(170.758 1212.172) rotate(135)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7165",
    "data-name": "Path 7165",
    d: "M6.309,1.594a1.3,1.3,0,0,1,2,0l3.738,4.485a1.3,1.3,0,0,1-1,2.14H3.573a1.3,1.3,0,0,1-1-2.14Z",
    transform: "translate(157.924 1222.943) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestMoneyConsumer);
export default __webpack_public_path__ + "static/media/request-money-consumer.58324161f182d1cac193422da50f0de9.svg";
export { ForwardRef as ReactComponent };